import { Component, ChangeDetectionStrategy } from '@angular/core';

import { HisColumnMetadata } from '../model/his-column-metadata';
import { HisSearchResultRow } from '../model/his-search-result';
import { HisSearchResultComponent } from './his-search-result.component';

import * as _ from 'lodash';

@Component( {
    selector: 'his-search-result-test',
    templateUrl: './his-search-result.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchResultTestComponent extends HisSearchResultComponent {

    private newColumnStart: HisColumnMetadata;
    private newColumnEnd: HisColumnMetadata;

    constructor() {
        super();
        this.newColumnStart = new HisColumnMetadata();
        this.newColumnStart.id = 'DynColumnFirst';
        this.newColumnStart.label = this.newColumnStart.id;
        this.newColumnStart.dataType = 'html-unsafe';

        this.newColumnEnd = new HisColumnMetadata();
        this.newColumnEnd.id = 'DynColumnLast';
        this.newColumnEnd.label = this.newColumnEnd.id;
        this.newColumnEnd.dataType = 'number';
    }

    configureColumnMetadata( columns: HisColumnMetadata[], searchConfigFile: string ): HisColumnMetadata[] {
        columns = _.clone( columns );
        columns.unshift( this.newColumnStart );
        columns.push( this.newColumnEnd );
        return columns;
    }

    configureRow( index: number, row: HisSearchResultRow, columns: HisColumnMetadata[], searchConfigFile: string ): HisSearchResultRow {
        row = _.clone( row );

        let templateFirstRow = `<button onclick="alert('First Button on Row '+(${index}+1))">Button ${index + 1}</button>`;
        row.values.unshift( templateFirstRow );

        row.values.push( 100 * row.values[10] );

        return row;
    }
}
